import { onMounted, reactive, ref, toRefs } from "vue";
import { ElMessage } from "element-plus";
//socket
export function useWebSocketFn(getSocketDataCallback) {
  function judgeDataType(data) {
    // 检查是否为JSON对象，这里通过尝试解析来判断

    try {
      if (
        typeof JSON.parse(data) === "object" &&
        !Array.isArray(JSON.parse(data))
      ) {
        return JSON.parse(data);
      }
    } catch (e) {
      // 如果解析失败，则不是有效的JSON格式

      function isChinese(str) {
        // 正则表达式：匹配所有汉字
        const regex = /^[\u4e00-\u9fa5]+$/;
        return regex.test(str);
      }

      function isHexString(str) {
        // 匹配十六进制字符串（纯数字0-9和字母a-fA-F组成）
        const regex = /^[0-9a-fA-F]+$/;
        return regex.test(str) && str.length > 0;
      }

      let result = isChinese(data);
      // console.log("111", result);

      if (result == true) {
        return ElMessage(data);
      }

      // 如果是十六进制字符串，也继续走
      if (isHexString(data)) {
        return data;
      }

      return false;
    }

    // 如果以上都不是，则归类为其他类型
    return false;
  }

  let timer = ref(null);
  let webSocket = ref(null);
  let webSocketUrl = ref(null);
  let webSocketState = ref(false);
  let webSocketIndex = ref(0);
  let activeCloseState = ref(false);

  //初始化建立链接
  function initSocket(url) {
    if (webSocketState.value == true) return;

    // 重置主动关闭状态，允许重新连接
    activeCloseState.value = false;

    //检查后台数据有没有发生变化,有变化就刷新数据
    // const url = 'wss://lslk.lsstjt.com/websocket';
    webSocketUrl.value = url;
    // 创建WebSocket实例
// url  wss://huyu3d.cn/websocket
    // webSocket.value = new WebSocket(url);
    // webSocket.value = new WebSocket(`ws://${location.host}/websocket`);
    // 使用环境变量配置 WebSocket 地址，兼容测试环境和正式环境
    const wsHost = import.meta.env.VITE_APP_WEBSOCKET_TARGET || ('wss://' + window.location.host);
    webSocket.value = new WebSocket(wsHost + '/websocket');


    // console.log("建立链接");
    monitorSocket();
  }
  //监听
  function monitorSocket() {
    //建立链接
    webSocket.value.onopen = (res, item) => {
      console.log("建立链接", webSocketUrl.value, res, item);
      webSocketState.value = true;
    };

    // 监听WebSocket连接关闭事件
    webSocket.value.onclose = () => {
      console.log("连接断开", activeCloseState.value ? "（主动关闭）" : "（被动断开）");
      if (activeCloseState.value == true) return;
      timer.value = setTimeout(() => {
        webSocket.value = null;
        webSocketState.value = false;
        passiveCloseSocket();
        initSocket(webSocketUrl.value);
        clearTimeout(timer.value);
        timer.value = null;
      }, 2000);
    };
    webSocket.value.onerror = (res) => {
      console.log("WebSocket连接打开失败1，请检1查！");
      // timer.value = setTimeout(() => {
      //   passiveCloseSocket();
      //   initSocket(webSocketUrl.value);
      //   clearTimeout(timer.value);
      //   timer.value = null;
      // }, 2000);
    };
  }

  //发送信息
  function sendSocketData(value) {
    console.log("发送消息", JSON.stringify(value));
    if (webSocket.value == null) return;
    webSocket.value.send(JSON.stringify(value));
  }

  //监听消息
  function monitorMessages(callback) {
    if (webSocket.value == null) return;

    webSocket.value.onmessage = (res) => {
      if (webSocketIndex.value == 0) {
        webSocketIndex.value = res.data;
      }

      console.log("监听消息",  res.data);

      let value = judgeDataType(res.data);
      console.log("监听消息", value);
      if (value == false) return;

      getSocketData(value, callback);
    };
  }

  //收到的命令
  function getSocketData(res, callback) {
    // console.log("收到的命令", res,callback);

    if (!callback) return;
    callback(res);
  }

  //主动关闭
  function activeCloseSocket() {
    if (webSocket.value == null) return;
    activeCloseState.value = true;
    console.log("主动关闭连接");
    webSocket.value.close();
    webSocketState.value = false;
  }

  //被动关闭
  function passiveCloseSocket() {
    if (webSocket.value == null) return;
    activeCloseState.value = false;
    webSocket.value.close();
    webSocketState.value = false;
  }

  return {
    initSocket,
    sendSocketData, //发送信息
    monitorMessages, //监听消息
    activeCloseSocket, //主动关闭
    webSocketIndex,
  };
}
